module.exports = __webpack_public_path__ + "static/media/landpage-login.fee2be9c.png";